export type LocaleKey = 'en' | 'es-419' | 'de' | 'it' | 'fr';

export interface Translations {
  contactInformation: string;
  paymentInformation: string;
  processing: string;
  shippingInformation: string;
  orderDetails: string;
  total: string;
  termsText: string;
  termsOfService: string;
}

export const translations: Record<LocaleKey, Translations> = {
  'en': {
    contactInformation: 'Contact Information',
    paymentInformation: 'Payment Information',
    processing: 'Processing...',
    shippingInformation: 'Shipping Information',
    orderDetails: 'Order Details',
    total: 'Total',
    termsText: 'By clicking {0} you agree to the',
    termsOfService: 'Terms of Service'
  },
  'es-419': {
    contactInformation: 'Información de Contacto',
    paymentInformation: 'Información de Pago',
    processing: 'Procesando...',
    shippingInformation: 'Información de Envío',
    orderDetails: 'Detalles del Pedido',
    total: 'Total',
    termsText: 'Al hacer clic en {0} aceptas los',
    termsOfService: 'Términos de Servicio'
  },
  'de': {
    contactInformation: 'Kontaktinformationen',
    paymentInformation: 'Zahlungsinformationen',
    processing: 'Wird bearbeitet...',
    shippingInformation: 'Versandinformationen',
    orderDetails: 'Bestelldetails',
    total: 'Gesamtsumme',
    termsText: 'Durch Klicken auf {0} stimmen Sie den',
    termsOfService: 'Nutzungsbedingungen zu'
  },
  'it': {
    contactInformation: 'Informazioni di Contatto',
    paymentInformation: 'Informazioni di Pagamento',
    processing: 'Elaborazione in corso...',
    shippingInformation: 'Informazioni di Spedizione',
    orderDetails: 'Dettagli dell\'ordine',
    total: 'Totale',
    termsText: 'Cliccando su {0} accetti i',
    termsOfService: 'Termini di Servizio'
  },
  'fr': {
    contactInformation: 'Coordonnées',
    paymentInformation: 'Informations de Paiement',
    processing: 'Traitement en cours...',
    shippingInformation: 'Informations de Livraison',
    orderDetails: 'Détails de la Commande',
    total: 'Total',
    termsText: 'En cliquant sur {0} vous acceptez les',
    termsOfService: 'Conditions d\'Utilisation'
  },
};

export const getTranslation = (locale: string = 'en'): Translations => {
  // Default to 'en' if the locale doesn't exist in our translations
  const safeLocale = translations[locale as LocaleKey] ? (locale as LocaleKey) : 'en';
  return translations[safeLocale];
};
